import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import 'Components/nurikae/general_modal/component'
import 'Components/nurikae_site/pages/company/show/sp/partials/supported_services/component'
import 'Components/nurikae/tooltip/component'

const switchTab = () => {
  const ROOT_TARGET_SELECTOR = '.js-switchTab-root-target'
  const MODAL_TRIGGER_SELECTOR = '.js-switchTab-modal-trigger'
  const SWITCH_TRIGGER_SELECTOR = '.js-switchTab-switch-trigger'
  const LABEL_TARGET_SELECTOR = '.js-switchTab-label-target'

  // カレントクラス名定義
  const SWITCH_TRIGGER_CURRENT_CLASS_NAME = 'company-sp-mv-text-content-modal__tab--current'
  const PREFECTURE_LABEL_CURRENT_CLASS_NAME = 'company-sp-mv-text-content-modal__prefecture--current'

  // data属性名定義
  const DATA_SHOW_CONTENTS_TYPE = 'show-contents-type'
  const DATA_CONTENTS_TYPE = 'contents-type'
  const DATA_PREFECTURE_IDS = 'prefecture-ids'
  const DATA_PREFECTURE_ID = 'prefecture-id'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $modalTrigger = $(root).find(MODAL_TRIGGER_SELECTOR)
    const $switchTrigger = $(root).find(SWITCH_TRIGGER_SELECTOR)
    const $labelTarget = $(root).find(LABEL_TARGET_SELECTOR)

    // 都道府県ラベルのカレント切り替え処理
    const changeCurrentPrefectureLabel = ($currentTrigger) => {
      const prefectureIds = $currentTrigger.data(DATA_PREFECTURE_IDS)
      $labelTarget.removeClass(PREFECTURE_LABEL_CURRENT_CLASS_NAME)
      $labelTarget.each((index, label) => {
        if (prefectureIds.includes($(label).data(DATA_PREFECTURE_ID))) {
          $(label).addClass(PREFECTURE_LABEL_CURRENT_CLASS_NAME)
        } else {
          $(label).removeClass(PREFECTURE_LABEL_CURRENT_CLASS_NAME)
        }
      })
    }

    // モーダルが開かれたときの処理
    $modalTrigger.on('click', (event) => {
      const showContentsType = $(event.currentTarget).data(DATA_SHOW_CONTENTS_TYPE)
      const $currentSwitchTrigger = $switchTrigger.filter(`[data-${DATA_CONTENTS_TYPE}="${showContentsType}"]`)

      // タブボタンのカレント切り替え
      $switchTrigger.removeClass(SWITCH_TRIGGER_CURRENT_CLASS_NAME)
      $currentSwitchTrigger.addClass(SWITCH_TRIGGER_CURRENT_CLASS_NAME)

      // 都道府県ラベルのカレント切り替え
      changeCurrentPrefectureLabel($currentSwitchTrigger)
    })

    // タブが切り替えられたときのカレント切り替え処理
    $switchTrigger.on('click', (event) => {
      $switchTrigger.removeClass(SWITCH_TRIGGER_CURRENT_CLASS_NAME)
      $(event.currentTarget).addClass(SWITCH_TRIGGER_CURRENT_CLASS_NAME)

      // 都道府県ラベルのカレント切り替え
      changeCurrentPrefectureLabel($(event.currentTarget))
    })
  })
}

$(() => {
  // 所在地と対応エリアのタブ切り替え処理
  switchTab()
})
